export const CreditCardModalStatus = {
  NONE: "NONE",
  MONTHLY_NET_INCOME: "MONTHLY_NET_INCOME", //Monthly net income screen
  MONTHLY_NET_INCOME_ELIGIBLE: "MONTHLY_NET_INCOME_ELIGIBLE",
  MONTHLY_NET_INCOME_NOT_ELIGIBLE: "MONTHLY_NET_INCOME_NOT_ELIGIBLE", // Other bank credit cards screen
  EXISTING_CUSTOMER_CARD_SELECTION: "EXISTING_CUSTOMER_CARD_SELECTION",
  NEW_CUSTOMER_COMPANION_CARD: "NEW_CUSTOMER_COMPANION_CARD",
  EXISTING_CUSTOMER_COMPANION_CARD_OPTION: "EXISTING_CUSTOMER_COMPANION_CARD_OPTION",
  EXISTING_CUSTOMER_SUPPLEMENTARY_CARD: "EXISTING_CUSTOMER_SUPPLEMENTARY_CARD",
  COMPANION_CARD_SPLIT_THE_LIMIT: "COMPANION_CARD_SPLIT_THE_LIMIT",
  COMPANION_CARD_SHARE_THE_LIMIT: "COMPANION_CARD_SHARE_THE_LIMIT",
  COMPANION_CARD_REQUEST_A_NEW_CREDIT_LIMIT: "COMPANION_CARD_REQUEST_A_NEW_CREDIT_LIMIT",
  REQUIRED_DOCUMENT: "REQUIRED_DOCUMENT",
  FOREIGN_CURRENCY: "FOREIGN_CURRENCY",
};
